import * as yup from 'yup'

export const contactSchema = yup.object({
	response: yup
		.string()
		.min(10, 'Mínimo 10 caracteres')
		.max(500, 'Máximo 500 caracteres')
		.required('Debes escribir tu mensaje'),
})
